/** Shared landscape shutter placement for all capture screens */
export const landscapeShutterToolbarStyle = {
  position: "absolute",
  top: "50%",
  right: 20,
  left: "auto",
  bottom: "auto",
  zIndex: 30,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transform: "translateY(-50%)",
  pointerEvents: "none",
  margin: 0,
  padding: 8,
  width: "auto",
};

export const landscapeShutterButtonStyle = {
  pointerEvents: "auto",
};
